<template>
  <div>{{ value | formatDate }}</div>
</template>

<script>
import { toUniversalFormat } from '@/utils/dateutils'

const numReg = /^\d+$/

export default {
  name: 'DateTimeView',
  props: ['value'],
  filters: {
    formatDate(value) {
      if (typeof value === 'string') {
        if (numReg.test(value)) {
          return new Date(parseInt(value)).toLocaleString()
        }
        try {
          return new Date(value).toLocaleString()
        } catch (err) {
          console.warn('Failed to parse date string', value)
        }
      }
      if (typeof value === 'number') {
        return new Date(parseInt(value)).toLocaleString()
      }
      return toUniversalFormat(value)
    }
  }
}
</script>

<style scoped></style>
